import { CmsTypographyPicker } from "@/components/cms/theme/CmsTypographyPicker";
import { useCmsPageThemeForm } from "@/hooks/use-cms-page-theme-form";
import { useGetCmsTheme } from "@/api/cms";
import { useTranslation } from "react-i18next";

type Props = {
  formPrefix?: string;
};

export function CmsPageTypographyField({ formPrefix }: Props) {
  const { t } = useTranslation();
  const { pageFontFamily, pageFontVariant, setPageTheme } =
    useCmsPageThemeForm(formPrefix);
  const { data: cmsTheme } = useGetCmsTheme();

  const inheritedDisplayValue =
    cmsTheme != null
      ? {
          fontFamily: cmsTheme.defaultPageFontFamily,
          fontVariant: cmsTheme.defaultPageFontVariant,
        }
      : null;

  return (
    <div className="rounded-lg border border-slate-200 bg-transparent p-4">
      <CmsTypographyPicker
        label={t("cms.page.settings.typographyTitle")}
        description={t("cms.page.settings.typographyHint")}
        value={{
          fontFamily: pageFontFamily,
          fontVariant: pageFontVariant,
        }}
        onChange={({ fontFamily, fontVariant }) =>
          setPageTheme({ pageFontFamily: fontFamily, pageFontVariant: fontVariant })
        }
        allowNone
        inheritDisplayValue={inheritedDisplayValue}
        noneLabel={t("cms.page.settings.typographyInherited")}
      />
    </div>
  );
}
